import { render, staticRenderFns } from "./multiAssetsFaqPage.vue?vue&type=template&id=7af42914"
import script from "./multiAssetsFaqPage.vue?vue&type=script&lang=ts"
export * from "./multiAssetsFaqPage.vue?vue&type=script&lang=ts"
import style0 from "./multiAssetsFaqPage.vue?vue&type=style&index=0&id=7af42914&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports